import Button from '@axa-japan/design-system-react/Button';
import { ArrowIcon } from '@axa-japan/design-system-react/Icons';
import { useNavigate } from 'react-router-dom';
import { SEARCH_PARAMS_INTERNAL } from '../constants/auth';
import useGetConnectionType from '../hooks/useGetConnectionType';
import { useUserContext } from '../providers/UserProvider';
import { AUTH_TYPE } from '../types/auth';

const NotFound = () => {
  const { token } = useUserContext();
  const connectionType = useGetConnectionType();

  const navigate = useNavigate();
  if (token) {
    return (
      <div className="grid h-full w-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">404 | Page not found</h1>

          <p className="mt-6 text-base leading-7 text-gray-600">申し訳ありませんが、お探しのページは見つかりませんでした。</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button
              variant="filled"
              icon={<ArrowIcon rotation="180" />}
              iconPosition="left"
              onClick={() => navigate(connectionType === AUTH_TYPE.Internal ? `/?${SEARCH_PARAMS_INTERNAL}=${AUTH_TYPE.Internal}` : '/')}
            >
              トップページに戻る
            </Button>
          </div>
        </div>
      </div>
    );
  }
};

export default NotFound;
